<template>
    <QrHeader :text="trans('code.order-qr-code')" trans="code.order-qr-code"/>

    <div class="mt-4">
        <Preview :qr-code="qrCode" use-cropped-image/>

        <div class="flex justify-between mt-4">
            <QrButton
                :to="`/create/design/${qrCode.id}`"
                :text="trans('button.back')"
                trans="button.continue"
                secondary
                icon="arrow-left"
            />

            <div class="space-x-4">
                <QrButton
                    to="/dashboard"
                    :text="trans('button.finish-later')"
                    trans="button.finish-later"
                    secondary
                />

                <Order :qr-code="qrCode"/>
            </div>
        </div>
    </div>
</template>

<script setup>
import { trans } from "@/libs/helper.js";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { useQrCodesStore} from "@/store/qrCodes.js";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
import Preview from "@/components/qr-code/Preview.vue";
import Order from "@/components/qr-code/Order.vue";

const qrCodeStore = useQrCodesStore();
const { newQrCode, qrCode } = storeToRefs(qrCodeStore);

onMounted(() => {
    newQrCode.value.step = 4
});

</script>
